import ApiConnector from '@/backend/apiModels/CRUDrequest'
import { useRouter } from 'vue-router';
import { useErrorHandler } from '@/hooks/errorHandler';
import { createToaster } from "@meforma/vue-toaster";


const toaster = createToaster();
const api = new ApiConnector('api')
const namespaced = true
// const router = useRouter()

const state = {
  loading:false,
  waitSave:false,
  opendRoutes:[],
  closedRoutes:[],
  routes:[],
  myRoutes:[],
  clear:false,
};

const mutations = {
  setInAti(state,{id,status}){
    state.routes.map(route => {
      if(route.id === id){
        route.changed = true
        route.in_ati = status
        if(!status){
          route.update_status = 'delete'
        }else{
          route.update_status = 'update'
        }
      }
    })
  },

  changeWithoutUpdate(state,{id,value,name}){
    state.routes.map(route => {
      if(route.id === id && route[name] !== value){
        route.changed = true
        route[name] = value
      }
    })
  },

  setLoading(state, status) {
      state.loading = status;  
  },
  setRoutes(state, response) {
      state.routes = response
  },
  setMyRoutes(state, response) {
    state.myRoutes = response
  },

};

const getters = {
  changedRoutes(state){
    return state.routes.filter(route => route.changed)
  },
  getRouteId:(state)=>(name)=>{
    return state.routes.filter(route => route.route.trim().toLowerCase() === name.trim().toLowerCase())[0];
  },
  routeInAti(state){
    return state.routes.filter(route => route.in_ati)
  },
};

const actions = {
  async startLoadingRoutes({ commit },{request,response}){
    commit('setLoading', true)
    try{
      await request()
      if (response.value){
        commit('setRoutes',response.value)
      }
    }catch(error){
      const path =  useErrorHandler(error)
      // if(path) router.push(path)
    }  
    commit('setLoading', false)
  },

  async getRoutes({ dispatch }){
    const { response, request } = api.get('/ati/routes',{params:{}})
    await dispatch('startLoadingRoutes',{request,response})
  },


  async addNewRoute({dispatch},{form}){
    const { response, request } = api.post('/ati/routes',{form})
    await dispatch('startLoadingRoutes',{request,response})
    if(response.value){
      toaster.success('Маршрут создан')
    }
  },

  async updateRouteBid({dispatch,getters}){
    const { response, request } = api.put('/ati/routes/bid',getters.changedRoutes)
    await dispatch('startLoadingRoutes',{request,response})
    if(response.value){
      toaster.success('Задача на обновление добавлена')
    }
  },

  async updateRoute({dispatch,getters}){
    const { response, request } = api.put('/ati/routes',getters.changedRoutes)
    await dispatch('startLoadingRoutes',{request,response})
    if(response.value){      
      toaster.success('Маршрут обновлен')
    }

  },

  async resetRoute({dispatch},{id}){
    const { response, request } = api.post('/ati/routes/'+id+'/reset',{form:{}})
    await dispatch('startLoadingRoutes',{request,response})
    if(response.value){
      toaster.success('Маршрут сброшен')
    }
  },

  async cencelAll({commit}){
    const { response, request } = api.post('/ati/routes/delete-all',{form:{}})
    try{
      await request()
      if(response.value){
        commit('setRoutes',response.value)
        toaster.success('Маршруты отменены')
      }
    }catch(err){
      console.log(err)
      toaster.error('Не удалось отменить маршруты')
    }
  },

  async deleteRoute({commit},{id}){
    const { response, request } = api.delete('/ati/routes/'+id)
    try{
      await request()
      if(response.value){
        commit('setRoutes',response.value)
        toaster.success('Маршрут удален')
      }
    }catch(err){
      toaster.error('Не удалось удалить маршрут')
    }
  },

  async getMyRoutes({commit}){
    const { response, request } = api.get('/ati/my-route',{params:{}})
    try{
      commit('setLoading', true)
      await request()
      if(response.value){
        commit('setMyRoutes',response.value)
        // toaster.success('Маршрут обновлен')
      }
    }catch(err){
      toaster.error('Не удалось получить маршруты')
    }
    commit('setLoading', false)
  },

};

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced
};